import React from "react";
import CountryForm from "../CountryForm";
import { useParams } from "react-router-dom";

const AddCountry = () => {
  const params = useParams();
  return <CountryForm mode="ADD" param={params} />;
};

export default AddCountry;
